import * as React from 'react'
import { VariantProps, cva } from 'class-variance-authority'

export const $container = cva('mx-auto w-full', {
  variants: {
    size: {
      mini: 'px-6 lg:px-12 xl:px-[71px] max-w-screen-md',
      xs: 'px-6 lg:px-12 xl:px-16 max-w-[920px]',
      small: 'px-6 md:px-8 max-w-[1148px]',
      regular: 'px-6 lg:px-8 xl:px-16 max-w-screen-xl',
      large: 'px-6 md:px-8 max-w-[1440px]',
      xl: 'px-6 lg:px-12 xl:px-16 max-w-screen-3xl',
      infinit: 'px-4 md:px-12 xl:px-20',
    },
  },
  defaultVariants: {
    size: 'regular',
  },
})

type ContainerProps = React.JSX.IntrinsicElements['div'] & {
  as?: 'div' | 'section' | 'main' | 'footer'
} & VariantProps<typeof $container>

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className, size, as = 'div', ...rest }, ref) => {
    const Element: React.ElementType = as

    return (
      <Element
        ref={ref}
        className={$container({ size, class: className })}
        {...rest}
      >
        {children}
      </Element>
    )
  }
)
